/*
 *  -----------------------------------------------------------------------
 *    <copyright file="dark-tool-tip.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import Tooltip from '@mui/material/Tooltip';
import { withStyles } from 'tss-react/mui';
import './styles.scss';

const DarkTooltip = withStyles(Tooltip, (theme) => ({
    tooltip: {
        backgroundColor: '#212121',
        color: theme.palette.common.white,
        fontSize: 12,
        fontWeight: 400,
        fontFamily: 'Montserrat',
        padding: '5px 15px',
    },
    popper: {
        zIndex: 111111,
    },
    arrow: {
        color: '#212121',
    },
}));

export default DarkTooltip;
